module.exports = __webpack_public_path__ + "img/user-up-01.c6ba3b5c.svg";